import {
  type RecommendedScenario,
  type Scenario,
  type ScenarioSource,
  type SharedScenario
} from 'types/api/scenarios/scenario'

// The Backend will need to know the scenario type
// in order to know how to query it
export enum ScenarioType {
  RECOMMENDED = 'RECOMMENDED',
  SHARED = 'SHARED',
  GENERAL = 'GENERAL'
}

export function getScenarioType(
  scenario:
    | Partial<Scenario>
    | Partial<RecommendedScenario>
    | Partial<SharedScenario>
): ScenarioType {
  if ('sharedBy' in scenario) {
    return ScenarioType.SHARED
  }

  if ('org_id' in scenario) {
    return ScenarioType.GENERAL
  }

  return ScenarioType.RECOMMENDED
}

export function isScenario(
  scenario: ScenarioSource | undefined
): scenario is Scenario {
  return scenario !== undefined && 'guid' in scenario
}

export function isSharedScenario(
  scenario: Scenario | RecommendedScenario | SharedScenario
): scenario is SharedScenario {
  return scenario !== undefined && 'sharedFromScenario' in scenario
}
